import React, { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';
import { canAccess } from '../config/features';

/**
 * Feature wrapper component for conditional rendering based on feature flags
 * 
 * Usage:
 * <Feature name="correlationInsights">
 *   <CorrelationInsights />
 * </Feature>
 * 
 * @param {string} name - Feature name from features.js
 * @param {React.ReactNode} children - Components to render if feature is accessible
 * @param {React.ReactNode} fallback - Optional fallback content when feature is not accessible
 */
const Feature = ({ name, children, fallback = null }) => {
  const { center, loading } = useContext(AuthContext);
  
  // Don't render anything while auth is loading
  if (loading) {
    return null;
  }
  
  // Check if feature is accessible
  const hasAccess = canAccess(name, center);
  
  // Log feature access for debugging (only in development)
  if (process.env.NODE_ENV === 'development') {
    console.log(`Feature "${name}": ${hasAccess ? 'GRANTED' : 'DENIED'} for center:`, {
      centerName: center?.name,
      licenseLevel: center?.licenseLevel,
      hasAccess
    });
  }
  
  // Render children if access is granted, otherwise render fallback
  return hasAccess ? children : fallback;
};

export default Feature;